import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';

const EMOJI_LIST = ['🐐', '🌮', '❤️'];
const madeWithEmoji = EMOJI_LIST[Math.floor(Math.random() * EMOJI_LIST.length)];
const releaseYear = new Date().getFullYear();

function CopyrightText() {
  return (
    <Text component="span" color="tertiary">
      <FormattedMessage id="dashboard.footer.label" values={{ madeWithEmoji, releaseYear }} />
    </Text>
  );
}

export default CopyrightText;
